module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Sort.0c7d796c.svg";